<template>
    <div>
        <div class="exports1">
            <span class="exports2">补货明细表导出</span>
        </div>
        <div class="exports3">
            <div class="jgs012">
            <p class="jgs022">设备名称</p>
            <div class="bpk02jq2">
                <el-select v-model="djg" class="djs0412" filterable placeholder="请选择" @change="bpxz">
                <el-option
                    v-for="(item,index) in djArr"
                    :key="'dj'+index"
                    :label="item.name"
                    :value="item.id">
                </el-option>
                </el-select>
            </div>
            </div>
            <el-date-picker
            v-model="days"
            type="daterange"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div class="djt02s" @click="daochu">
            <img src="@/assets/imgs/08.png" class="djt03" alt="">
            <p class="djt04">导出</p>
          </div>
        </div>
    </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  import http from 'axios';
    export default {
        data(){
            return{
                djArr:[],
                pageSize:100,
                user:'',
                deviceid:'',
                days:[],
                djg:'',
                pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '清空',
                    onClick(picker) {
                    picker.$emit('pick', []);
                    }
                }]
                },
            }
        },
        created() {
            me = this;
            user = JSON.parse(sessionStorage.getItem('user'));
            me.user = JSON.parse(sessionStorage.getItem('user'));
        },
        mounted(){
            let data = {
                companyid:me.user.companyId,
                page:1,
                pageSize:me.pageSize,
            }
            let data1 = {
                page:1,
                pageSize:1000,
            }
            if (user.companyId != '1') {
                me.$set(data,'companyid',user.companyId);
                me.$set(data1,'companyid',user.companyId);
            }
            http.all([httpUser.getchannellist(data),httpUser.djglist(data1)]).then(http.spread(function (val1,val2) {
                console.log([val1,val2]);
                me.data = val1.data.dataList;
                me.totalPage = val1.data.totalNum
                me.data.forEach(function (item,index) {
                me.$set(item,'is_ed',false);
                })
                me.djArr = val2.data.dataList
                me.loading = false;
            }))
        },
        methods:{
            daochu(){
                if(me.days == '') {
                    me.$message.error('请选择时间');
                    return false;
                }
                let data = {
                    companyid:me.user.companyId,
                    deviceid:me.deviceid,
                    starttime:me.days[0],
                    endtime:me.days[1],
                }
                httpUser.exportbhmx(data).then(res=>{
                    const blob = new Blob([res],{ type: 'application/vnd.ms-excel'});//处理文档流
                    const fileName = '补货明细表.csv';
                    const elink = document.createElement('a');
                    elink.download = fileName;
                    elink.style.display = 'none';
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                    me.loading = false;
                    me.$Loading.finish();
                })
            },
            bpxz(e){//选中设备后
                me.deviceid = e
            }
        }
    }
</script>

<style scoped>
.exports1{
    width: 100%;
    padding-bottom: 10px;
}
.exports2{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    cursor: pointer;
}
.exports3{
    width: 100%;
    border-radius: 5px;
    background-color: white;
    padding: 25px 25px 25px 25px;
    display: flex;
}
.jgs012{
    display: flex;
}
.jgs022{
    font-size: 15px;
    color: #2176FA;
    line-height: 44px;
    padding-right: 15px;
}
.bpk02jq2{
    width: 200px;
    position: relative;
    display: flex;
    margin-right: 15px;
}
.djs0412{
    width: 100%;
    /* box-shadow: 0 2px 4px 0 rgb(0 0 0 / 25%); */
    border-radius: 5px;
}
.djt02s{
    width: 100px;
    margin-left: 20px;
    height: 40px;
    font-size: 16px;
    border-radius: 3px;
    background-color: #1FBB7D;
    display: flex;
    justify-content: center;
    cursor: pointer;
}
.djt03{
    width: 22px;
    height: 22px;
    margin-top: 11px;
}
.djt04{
    font-size: 22px;
    color: white;
    line-height: 44px;
    padding-left: 10px;
}
</style>